import React, { useState, useEffect } from 'react';  
import { Link } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle, Form } from 'reactstrap';

//import images
import logoSm from "../assets/images/logo-sm.png";
import logoDark from "../assets/images/logo-dark.png";
import logoLight from "../assets/images/logo-light.png";
import { layoutModeTypes } from "../Components/constants/layout";

//import Components
import SearchBar from '../Components/Common/SearchBar';
import LanguageDropdown from '../Components/Common/LanguageDropdown';
import WebAppsDropdown from '../Components/Common/WebAppsDropdown';
import MyCartDropdown from '../Components/Common/MyCartDropdown';
import FullScreenDropdown from '../Components/Common/FullScreenDropdown';
import NotificationDropdown from '../Components/Common/NotificationDropdown';
import ProfileDropdown from '../Components/Common/ProfileDropdown';
import LightDark from '../Components/Common/LightDark';
import CheckInOut from '../Components/Common/CheckInOut';

import { changeSidebarVisibility } from '../slices/thunks';
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';
import { subscribeToProfileUpdates, getBestProfilePhoto } from '../utils/profileUpdateHelper';

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass }) => {
    const dispatch = useDispatch();

    const profiledropdownData = createSelector(
        (state) => state.Profile,
        (user) => user.user
      );
    const user = useSelector(profiledropdownData);
    const [userName, setUserName] = useState("NoName");
    const [userRole, setUserRole] = useState(null); // Initialize as null to prevent premature rendering
    const [isUserDataLoaded, setIsUserDataLoaded] = useState(false); // Track if user data is loaded

    const [avatarUrl, setAvatarUrl] = useState(""); // Store uploaded avatar URL
    const [profileImageUrl, setProfileImageUrl] = useState(""); // Store uploaded profile image URL
    useEffect(() => {
        const loadUserData = () => {
            if (sessionStorage.getItem("user")) {
                const userobj = JSON.parse(sessionStorage.getItem("user"));
                console.log('Header - userobj', userobj.name);
                // Construct full name from firstName and lastName, fallback to name or fullName
                const fullName = userobj.firstName && userobj.lastName 
                    ? `${userobj.firstName} ${userobj.lastName}` 
                    : userobj.name || userobj.fullName || '';
                setUserName(fullName); 
                
                // Use the helper function to get the best profile photo
                const bestPhoto = getBestProfilePhoto(userobj);
                setAvatarUrl(bestPhoto);
                setProfileImageUrl(userobj.profile_picture_url);
                setUserRole(userobj.role);
                setIsUserDataLoaded(true);
            } else {
                // If no user data in session, still mark as loaded to prevent infinite loading
                setIsUserDataLoaded(true);
            }
        };
        
        // Load user data initially
        loadUserData();
        
        // Subscribe to profile updates
        const unsubscribeProfileData = subscribeToProfileUpdates(() => {
            console.log('Header - Profile data refreshed event received');
            loadUserData();
        }, 'profileDataRefreshed');
        
        const unsubscribeProfilePhoto = subscribeToProfileUpdates(() => {
            console.log('Header - Profile photo updated event received');
            loadUserData();
        }, 'profilePhotoUpdated');
        
        const unsubscribeAvatar = subscribeToProfileUpdates(() => {
            console.log('Header - Avatar updated event received');
            loadUserData();
        }, 'avatarUpdated');
        
        return () => {
            unsubscribeProfileData();
            unsubscribeProfilePhoto();
            unsubscribeAvatar();
        };
    }, [userName, user]);
    const selectDashboardData = createSelector(
        (state) => state.Layout,
        (sidebarVisibilitytype) => sidebarVisibilitytype.sidebarVisibilitytype
      );
    // Inside your component
    const sidebarVisibilitytype = useSelector(selectDashboardData);

    const [search, setSearch] = useState(false);
    const toogleSearch = () => {
        setSearch(!search);
    };

    const toogleMenuBtn = () => {
        var windowSize = document.documentElement.clientWidth;
        dispatch(changeSidebarVisibility("show"));

        if (windowSize > 767)
            document.querySelector(".hamburger-icon").classList.toggle('open');

        //For collapse horizontal menu
        if (document.documentElement.getAttribute('data-layout') === "horizontal") {
            document.body.classList.contains("menu") ? document.body.classList.remove("menu") : document.body.classList.add("menu");
        }

        //For collapse vertical and semibox menu
        if (sidebarVisibilitytype === "show" && (document.documentElement.getAttribute('data-layout') === "vertical" || document.documentElement.getAttribute('data-layout') === "semibox")) {
            if (windowSize < 1025 && windowSize > 767) {
                document.body.classList.remove('vertical-sidebar-enable');
                (document.documentElement.getAttribute('data-sidebar-size') === 'sm') ? document.documentElement.setAttribute('data-sidebar-size', '') : document.documentElement.setAttribute('data-sidebar-size', 'sm');
            } else if (windowSize > 1025) {
                document.body.classList.remove('vertical-sidebar-enable');
                (document.documentElement.getAttribute('data-sidebar-size') === 'lg') ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'lg');
            } else if (windowSize <= 767) {
                document.body.classList.add('vertical-sidebar-enable');
                document.documentElement.setAttribute('data-sidebar-size', 'lg');
            }
        }


        //Two column menu
        if (document.documentElement.getAttribute('data-layout') === "twocolumn") {
            document.body.classList.contains('twocolumn-panel') ? document.body.classList.remove('twocolumn-panel') : document.body.classList.add('twocolumn-panel');
        }
    };
    // Remove the hardcoded mode logic - we'll use layoutModeType directly
    return (
        <React.Fragment>
            <header id="page-topbar" className={headerClass}>
                <div className="layout-width">
                    <div className="navbar-header">
                        <div className="d-flex"  style={{marginLeft:'10px'}}>

                            <div className="navbar-brand-box horizontal-logo">
                               
                            </div>
                            <Link to="/home" className={`logo logo-dark`}> 
                                <span className="logo-lg">
                                    {/* Logo logic: Light mode shows light logo, Dark mode shows dark logo */}
                                    <img src={layoutModeType === layoutModeTypes.LIGHTMODE ? logoLight : logoDark} alt="" height="40" />
                                </span>
                            </Link>
 
                            {/* <button
                                onClick={toogleMenuBtn}
                                type="button"
                                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                                id="topnav-hamburger-icon">
                                <span className="hamburger-icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </button> */}


                        </div>

                        <div className="d-flex align-items-center">

                            <SearchBar />
                            <Dropdown isOpen={search} toggle={toogleSearch} className="d-md-none topbar-head-dropdown header-item">
                                <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
                                    <i className="bx bx-search fs-22"></i>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                                    <Form className="p-3">
                                        <div className="form-group m-0">
                                            <div className="input-group">
                                                <input type="text" className="form-control" placeholder="Search ..."
                                                    aria-label="Recipient's username" />
                                                <button className="btn btn-primary" type="submit"><i
                                                    className="mdi mdi-magnify"></i></button>
                                            </div>
                                        </div>
                                    </Form>
                                </DropdownMenu>
                            </Dropdown>
                            {/* LanguageDropdown */}
                            {/* <LanguageDropdown /> */}
                            {/* WebAppsDropdown */}
                            <WebAppsDropdown />

                            {/* MyCartDropdwon */}
                            <MyCartDropdown />
                            <Link to="/calender" className=" btn-icon btn-topbar btn-ghost-secondary rounded-circle">
                                <i className="bx bx-calendar fs-22"></i> 
                            </Link>
                            
                           

                            {/* FullScreenDropdown */}
                            <FullScreenDropdown />

                            {/* Dark/Light Mode set */}
                            <LightDark
                                layoutMode={layoutModeType}
                                onChangeLayoutMode={onChangeLayoutMode}
                            />

                            {/* NotificationDropdown */}
                            <NotificationDropdown />

                            {/* ProfileDropdown */}
                            {isUserDataLoaded && userRole && userRole !== "customer" ? <CheckInOut/> : null}
                            <ProfileDropdown />
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    );
};

export default Header;